import React, { Component, PropTypes } from 'react';
import ConfigurationCheckbox from '../../widgets/ConfigurationCheckbox';
import ReactSparkTextInput from '../../widgets/ReactSparkTextInput';
import ControlledSelect from '../../ui/sabre-spark-react-ex/select/index';
import { get } from 'lodash';
import { isEqual } from 'lodash';
import ConfigManage from './configurationListSettings/index';
import {
    showUnavailableHotels,
    hotelListDisplay,
    altAvailDistanceLimit,
    altAvailDistanceLimitUnit,
    altAvailType,
    altAvailSortOrder,
    showLeadAvailabilityPrices
} from '../../../constants/configurationListItems';
import { getText } from '../../../../lib/utils';
import Validator from '../../../utils/Validator';
import * as ReactDOM from 'react-dom';

class HotelConfiguration extends Component {
    constructor() {
        super(...arguments);
        this.sections = [];
    }
    capitalize(word) {
        return word[0].toUpperCase() + word.slice(1);
    }
    registerSection(key) {
        return node => (this.sections[key] = node);
    }
    sectionStyleHandler(key) {
        return this.props.searchIndex !== undefined && this.props.searchIndex.indexOf(key) === -1
            ? { display: 'none' }
            : {};
    }
    componentDidMount() {
        if (this.props.onIndex) {
            this.sections.forEach((section, key) => {
                this.props.onIndex(getText(ReactDOM.findDOMNode(section)), [key]);
            });
        }
    }
    render() {
        const unavailableHotelsValue = this.props.currentConfigCopy.hotelList
            ? isEqual(this.props.currentConfigCopy.hotelList.showUnavailableHotels, 'availableOnly')
            : get(this.props.currentConfigCopy, 'showAvailableHotelsOnly');

        return (
            <div className="spark-panel__content">
                <section className="row spark-panel__section">
                    <div className="col-xs-12">
                        <h3>Hotel Settings</h3>
                    </div>
                </section>
                <section className="row spark-panel__section">
                    <div className="col-xs-12">
                        <h4>General</h4>
                        <ControlledSelect
                            label="Unavailable Hotels"
                            isDisabled={this.props.isDisabled}
                            value={String(unavailableHotelsValue)}
                            options={showUnavailableHotels}
                            onChange={value => {
                                this.props.setConfigText('showAvailableHotelsOnly', JSON.parse(value));
                                this.props.setConfigText('hotelList', false);
                            }}
                        />
                        <ControlledSelect
                            label="Lead Availability Price Display"
                            value={get(this.props.currentConfigCopy, 'leadAvailabilityPriceDisplay')}
                            isDisabled={this.props.isDisabled}
                            options={showLeadAvailabilityPrices.map(v => {
                                return { key: v.key, label: v.label };
                            })}
                            onChange={value => {
                                this.props.setConfigText('leadAvailabilityPriceDisplay', value);
                            }}
                        />
                        <ConfigurationCheckbox
                            title="Enable coupons"
                            ref={this.registerSection(10)}
                            style={this.sectionStyleHandler(10)}
                            isDisabled={this.props.isDisabled}
                            code={'coupons.enabled'}
                            onChange={this.props.toggleConfigBoolean}
                            value={this.props.currentConfigCopy.coupons.enabled}
                        />
                    </div>
                </section>
                <section className="row spark-panel__section">
                    <div className="col-xs-12">
                        <h4>Alternate Availability</h4>
                        <ConfigurationCheckbox
                            title="Filter Alternate Availability By Brand"
                            ref={this.registerSection(5)}
                            style={this.sectionStyleHandler(5)}
                            isDisabled={this.props.isDisabled}
                            code={'filterAltAvailResultsByBrand'}
                            onChange={this.props.toggleConfigBoolean}
                            value={this.props.currentConfigCopy.filterAltAvailResultsByBrand}
                        />
                        <ControlledSelect
                            label="Alt Availability Distance Limit"
                            isDisabled={this.props.isDisabled}
                            value={this.props.currentConfigCopy.altAvailDistanceLimit}
                            options={altAvailDistanceLimit}
                            onChange={value => {
                                this.props.setConfigNumber('altAvailDistanceLimit', value);
                            }}
                        />
                    </div>
                    <div className="col-sm-12" ref={this.registerSection(7)} style={this.sectionStyleHandler(7)}>
                        <div>Alt Availability Distance Limit Units</div>
                        <ControlledSelect
                            label="Alt Availability Distance Limit Units"
                            isDisabled={this.props.isDisabled}
                            value={this.props.currentConfigCopy.altAvailDistanceLimitUnit}
                            options={altAvailDistanceLimitUnit}
                            onChange={value => {
                                this.props.setConfigText('altAvailDistanceLimitUnit', value);
                            }}
                        />
                    </div>
                    <div className="col-sm-12" ref={this.registerSection(8)} style={this.sectionStyleHandler(8)}>
                        <div>Alternate Availabilty Type</div>
                        <ControlledSelect
                            label="Alternate Availability Type"
                            isDisabled={this.props.isDisabled}
                            value={this.props.currentConfigCopy.altAvailType}
                            options={altAvailType}
                            onChange={value => {
                                this.props.setConfigText('altAvailType', value);
                            }}
                        />
                    </div>
                    <div className="col-sm-12" ref={this.registerSection(9)} style={this.sectionStyleHandler(9)}>
                        <ControlledSelect
                            label="Alternate Availability Sort Order"
                            isDisabled={this.props.isDisabled}
                            value={
                                this.props.currentConfigCopy.altAvailSortOrder === 'HotelName'
                                    ? 'hotelName'
                                    : this.props.currentConfigCopy.altAvailSortOrder
                            }
                            options={altAvailSortOrder}
                            onChange={value => {
                                this.props.setConfigText('altAvailSortOrder', value);
                            }}
                        />
                    </div>
                </section>
                <section className="row" ref={this.registerSection(10)} style={this.sectionStyleHandler(10)}>
                    <div className="col-sm-12" ref={this.registerSection(11)} style={this.sectionStyleHandler(11)}>
                        <h4>Hotel List settings</h4>
                        <ControlledSelect
                            label="Hotel List Display"
                            value={this.props.currentConfigCopy.mapOnChainPage.hotelListDisplay}
                            options={hotelListDisplay}
                            onChange={value => {
                                this.props.setConfigText('mapOnChainPage.hotelListDisplay', value);
                            }}
                            isDisabled={this.props.isDisabled}
                        />
                    </div>
                    <div className="col-sm-12" ref={this.registerSection(11)} style={this.sectionStyleHandler(11)}>
                        <div className="row spark-margin-bottom">
                            <div className="col-sm-12">
                                <ReactSparkTextInput
                                    label="Maximum # of hotels to request (10 - 1000)"
                                    value={this.props.currentConfigCopy.mapOnChainPage.numberOfFetchedHotels}
                                    onBlur={event => {
                                        this.props.setConfigText(
                                            'mapOnChainPage.numberOfFetchedHotels',
                                            Validator.validNumberInt(event.target.value, 10, 1000)
                                        );
                                    }}
                                    onChange={event => {
                                        this.props.setConfigText(
                                            'mapOnChainPage.numberOfFetchedHotels',
                                            Validator.validNumberIntType(event.target.value)
                                        );
                                    }}
                                    isDisabled={this.props.isDisabled}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12" ref={this.registerSection(12)} style={this.sectionStyleHandler(12)}>
                        <h6>Center map position</h6>
                        <div className="row spark-margin-bottom">
                            <div className="col-xs-6">
                                <ReactSparkTextInput
                                    label="Latitude (-90° - 90°)"
                                    value={this.props.currentConfigCopy.mapOnChainPage.center.lat}
                                    onBlur={event => {
                                        this.props.setConfigText(
                                            'mapOnChainPage.center.lat',
                                            Validator.validGeoCoordinate(event.target.value, 'lat')
                                        );
                                    }}
                                    onChange={event => {
                                        this.props.setConfigText(
                                            'mapOnChainPage.center.lat',
                                            Validator.validNumberFloat(event.target.value)
                                        );
                                    }}
                                    isDisabled={this.props.isDisabled}
                                />
                            </div>
                            <div className="col-xs-6">
                                <ReactSparkTextInput
                                    label="Longitude (-180° - 180°)"
                                    value={this.props.currentConfigCopy.mapOnChainPage.center.lng}
                                    onBlur={event => {
                                        this.props.setConfigText(
                                            'mapOnChainPage.center.lng',
                                            Validator.validGeoCoordinate(event.target.value, 'lng')
                                        );
                                    }}
                                    onChange={event => {
                                        this.props.setConfigText(
                                            'mapOnChainPage.center.lng',
                                            Validator.validNumberFloat(event.target.value)
                                        );
                                    }}
                                    isDisabled={this.props.isDisabled}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12" ref={this.registerSection(13)} style={this.sectionStyleHandler(13)}>
                        <h6>Default map values</h6>
                        <div className="row spark-margin-bottom">
                            <div className="col-xs-12">
                                <ConfigurationCheckbox
                                    title="Fit Map to hotels"
                                    ref={this.registerSection(15)}
                                    style={this.sectionStyleHandler(15)}
                                    code={'mapOnChainPage.fitMapToHotels'}
                                    value={this.props.currentConfigCopy.mapOnChainPage.fitMapToHotels}
                                    onChange={this.props.toggleConfigBoolean}
                                    isDisabled={this.props.isDisabled}
                                />
                            </div>
                            <div className="col-xs-6">
                                <ReactSparkTextInput
                                    label="Zoom (1-12)"
                                    value={this.props.currentConfigCopy.mapOnChainPage.zoom}
                                    onBlur={event => {
                                        this.props.setConfigText(
                                            'mapOnChainPage.zoom',
                                            Validator.validNumberInt(event.target.value, 1, 12)
                                        );
                                    }}
                                    onChange={event => {
                                        this.props.setConfigText(
                                            'mapOnChainPage.zoom',
                                            Validator.validNumberIntType(event.target.value)
                                        );
                                    }}
                                    isDisabled={this.props.isDisabled}
                                />
                            </div>
                            <div className="col-xs-6">
                                <ReactSparkTextInput
                                    label="Search radius (1-3000 km)"
                                    value={this.props.currentConfigCopy.mapOnChainPage.searchRadius}
                                    onBlur={event => {
                                        this.props.setConfigText(
                                            'mapOnChainPage.searchRadius',
                                            Validator.validNumberInt(event.target.value, 1, 3000)
                                        );
                                    }}
                                    onChange={event => {
                                        this.props.setConfigText(
                                            'mapOnChainPage.searchRadius',
                                            Validator.validNumberIntType(event.target.value)
                                        );
                                    }}
                                    isDisabled={this.props.isDisabled}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-12" ref={this.registerSection(16)} style={this.sectionStyleHandler(16)}>
                        <h6>Custom destination</h6>
                        <ConfigManage
                            tableMultiColumns={true}
                            columns={[
                                {
                                    key: 'label',
                                    inputType: 'text',
                                    value: 'Label'
                                },
                                {
                                    key: 'location.lat',
                                    inputType: 'number',
                                    value: 'Latitude (-90° - 90°)',
                                    validator: {
                                        type: 'geo',
                                        type_geo: 'lat',
                                        min: -90,
                                        max: 90
                                    }
                                },
                                {
                                    key: 'location.lng',
                                    inputType: 'number',
                                    value: 'Longitude (-180° - 180°)',
                                    validator: {
                                        type: 'geo',
                                        type_geo: 'lng',
                                        min: -180,
                                        max: 180
                                    }
                                },
                                {
                                    key: 'location.zoom',
                                    inputType: 'number',
                                    value: 'Zoom (1-12)',
                                    validator: {
                                        type: 'int',
                                        min: 1,
                                        max: 12
                                    }
                                },
                                {
                                    key: 'location.radius',
                                    inputType: 'number',
                                    value: 'Search radius (1-3000 km)',
                                    validator: {
                                        type: 'int',
                                        min: 1,
                                        max: 3000
                                    }
                                }
                            ]}
                            list={this.props.currentConfigCopy.mapOnChainPage.destinations}
                            isDisabled={this.props.isDisabled}
                            addConfigRow={() => this.props.addConfigRow('hotelMapSettings')}
                            changeConfigRow={(oldIndex, newIndex) => {
                                this.props.changeConfigRow('hotelMapSettings', oldIndex, newIndex);
                            }}
                            editConfigRow={(editCode, index, value) => {
                                this.props.editConfigRow('hotelMapSettings', editCode, index, value);
                            }}
                            deleteConfigRow={index => {
                                this.props.deleteConfigRow('hotelMapSettings', index);
                            }}
                        />
                    </div>
                </section>
            </div>
        );
    }
}

HotelConfiguration.propTypes = {
    children: PropTypes.element
};

export default HotelConfiguration;



// WEBPACK FOOTER //
// ./src/components/pages/pages/HotelConfiguration.js